export default "__VITE_ASSET__Ddf5eYCC__"